import { Navigate, useSearchParams } from "react-router-dom";
import { DASHBOARD_REQUESTS_TAB, parseLegacyRequestsTab } from "@/pages/dashboard/dashboardTab.const";

/** Redirect legacy /requests to dashboard requests section. */
export default function InterestsPage() {
  const [searchParams] = useSearchParams();
  const filter = parseLegacyRequestsTab(searchParams.get("tab"));
  return <Navigate to={`/dashboard?tab=${DASHBOARD_REQUESTS_TAB}&filter=${filter}`} replace />;
}
